module.exports = __webpack_public_path__ + "static/media/logo.834196d6.jpg";